import { useNavigate } from "react-router-dom";
import { Home, UserRound, Bell, BarChart3, LogOut, CalendarDays, Lock, ArrowLeft } from "lucide-react";
import BrandMark from "@/components/marketing/BrandMark";
import { api } from "@/lib/api";

const TABS = [
  { id: "home", label: "Home", icon: Home },
  { id: "calendar", label: "Calendar", icon: CalendarDays },
  { id: "mypage", label: "My Page", icon: UserRound },
  { id: "now", label: "Now", icon: Bell },
  { id: "activity", label: "Activity", icon: BarChart3 },
];

export const ReadOnlyNote = () => (
  <p data-testid="readonly-note" className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[11px] font-semibold text-amber-800">
    <Lock size={11} /> Admin view — read only
  </p>
);

const AppShell = ({ tab, setTab, adminView = false, businessName = "", children }) => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await api("/auth/logout", { method: "POST" });
    } catch (e) {}
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#F7F7F5] font-sans" data-testid="app-shell">
      <header className="sticky top-0 z-40 border-b border-guinep-line/50 bg-[#F7F7F5]/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-md items-center justify-between px-5 py-4">
          <div className="flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-md bg-guinep-soft">
              <BrandMark size={14} />
            </span>
            <span className="font-serif text-base font-semibold tracking-tight text-guinep-ink">Guinep Seed</span>
          </div>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="text-guinep-mute transition-colors hover:text-guinep-ink"
            aria-label="Log out"
          >
            <LogOut size={18} />
          </button>
        </div>
        {adminView && (
          <div data-testid="admin-view-banner" className="border-t border-amber-200 bg-amber-50">
            <div className="mx-auto flex max-w-md items-center justify-between gap-3 px-5 py-1.5">
              <p className="truncate text-[11px] font-semibold text-amber-800">Admin view — viewing {businessName}</p>
              <button
                data-testid="return-to-admin"
                onClick={() => navigate("/admin")}
                className="inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-800 px-3 py-1 text-[10px] font-semibold text-white transition-colors hover:bg-amber-900"
              >
                <ArrowLeft size={10} /> Return to Admin
              </button>
            </div>
          </div>
        )}
      </header>

      <main className="mx-auto max-w-md px-5 pb-28 pt-7">{children}</main>

      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-guinep-line/50 bg-white">
        <div className="mx-auto flex max-w-md items-center justify-around px-2 py-2">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`flex flex-col items-center gap-1 rounded-lg px-4 py-1.5 text-[11px] font-medium transition-colors ${
                tab === t.id ? "text-guinep-deep" : "text-guinep-mute/70 hover:text-guinep-ink"
              }`}
            >
              <t.icon size={19} strokeWidth={tab === t.id ? 2.4 : 2} />
              {t.label}
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default AppShell;
